import * as React from 'react';
import Menu from '@mui/material/Menu';
import * as AppPics from 'assets/images';
import { withStyles } from '@material-ui/core/styles';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import MarkunreadOutlinedIcon from '@material-ui/icons/MarkunreadOutlined';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ChatBubbleIcon from '@material-ui/icons/ChatBubble';
import useBellNotification from 'hooks/API/GET/useBellNotification';
import { withRouter } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';
import useManageBellNotification from 'hooks/API/useManageBellNotification';

const styles = (theme) => ({
  item: {
    padding: 0,
    minWidth: '20px',
  },
});

function ActionCenter(props) {
  const { classes } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    if (!results) return;
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [open2, setOpen] = React.useState(true);

  const handleClick2 = () => {
    setOpen(!open2);
  };

  const { isLoading, data } = useBellNotification({ enabled: true });
  const results = data?.data || [];

  const { isLoading: isUpdating, mutate } = useManageBellNotification();

  function handleMarkAsRead(args = {}) {
    if (isLoading) return;
    if (isUpdating) return;

    mutate(args);
  }

  return (
    <div>
      <button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={results?.length ? handleClick : null}
      >
        <img src={AppPics.TopMenuBellSvg} alt="Notifications" />
        <span>Alerts</span>
        <span className="menuWrap__menuIndi">{results?.length}</span>
      </button>
      {open && (
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
        >
          {results?.length > 0 ? (
            <>
              {results?.map((item) => {
                const { date, commentId } = item || {};
                const { commentAdded, subtopic, topic, chapter, course } = item?.labels || {};
                let __href = `/classes/${item.classId}/courses/${item.course}/chapters/${item.chapter}/topics/${item.topic}/contentPreview?lessonType=notes&open=note&utm_source=review-tiles`;
                if (item?.subtopic) __href += `&subtopic=${item.subtopic}`;
                if (commentId) __href += `&replyCommentHash=${commentId}`;

                function handleGoto(to) {
                  if (to) props?.history?.push(to);
                }

                return (
                  <List dense disablePadding>
                    <ListItem
                      secondaryAction={
                        <Tooltip title="Mark as read">
                          <ListItemButton
                            classes={{ root: classes.item }}
                            edge="end"
                            aria-label="delete"
                            onClick={() => {
                              handleMarkAsRead({ id: commentId });
                            }}
                          >
                            <MarkunreadOutlinedIcon />
                          </ListItemButton>
                        </Tooltip>
                      }
                    >
                      <ListItemAvatar>
                        <ListItemIcon>
                          <ChatBubbleIcon />
                        </ListItemIcon>
                      </ListItemAvatar>
                      <ListItem component="a" href={__href}>
                        <ListItemText
                          primary={`A new comment has been added by ${commentAdded} for the title ${
                            subtopic || topic
                          } under ${chapter} of ${course}`}
                          secondary={date}
                        />
                      </ListItem>

                      {/* <ListItemText
                        primary={
                          <span
                            onClick={() => {
                              handleGoto(__href);
                            }}
                            style={{ cursor: 'pointer' }}
                          >
                            {`A new comment has been added by ${commentAdded} for the title ${
                              subtopic || topic
                            } under ${chapter} of ${course}`}
                          </span>
                        }
                        secondary={date}
                      /> */}
                    </ListItem>
                  </List>
                );
              })}
              <ListItem component="a" href={'/users/action_center'}>
                View all
              </ListItem>
            </>
          ) : null}

          {/* <List
            sx={{ width: '100%', bgcolor: 'background.paper' }}
            dense
            component="nav"
            aria-labelledby="nested-list-subheader"
            subheader={
              <ListSubheader component="div" id="nested-list-subheader">
                Action center
              </ListSubheader>
            }
          >
            <ListItemButton>
              <ListItemIcon>
                <ChatBubbleIcon />
              </ListItemIcon>
              <ListItemText
                primary="You have a new comment from Teacher 1"
                secondary={`12 July, 2023 11:34pm`}
              />
              <ListItemText primary="Mark as read" />
            </ListItemButton>
          </List> */}
        </Menu>
      )}
    </div>
  );
}

export default withStyles(styles)(withRouter(ActionCenter));
